<div class="horizontal-button-group"
     [class.input-invalid]="invalid()"
     [attr.data-testid]="testId()">
  @for (button of buttons(); track $index) {
    <p-button [label]="button.label"
              type="button"
              [ariaLabel]="button.ariaLabel"
              [icon]="button.icon"
              [iconPos]="button.iconPos ?? 'left'"
              [severity]="button.severity || null"
              [outlined]="!!button.outlined"
              [text]="!!button.text"
              [disabled]="!!button.disabled"
              [loading]="!!button.loading"
              [styleClass]="resolveStyleClass(button)"
              (click)="handleClick(button)"
              [attr.data-testid]="button.testId || null" />
  }
</div>